import styled from 'styled-components';

const StyledSpiderChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  max-height: 500px;
`;

export { StyledSpiderChartWrapper };
